import { Link } from 'react-router-dom';
import { styled } from 'linaria/react';

export const StyledLink = styled(Link)`
  color: inherit;
`;
